import React, { useState, useEffect } from "react";
import "./CustomSlider.css";
import {
  AutorenewRounded,
  DeleteOutlineOutlined,
  KeyboardArrowLeftRounded,
  KeyboardArrowRightRounded,
  RefreshOutlined,
  Replay10Rounded,
  ScreenRotationOutlined,
} from "@mui/icons-material";
import { Typography } from "@mui/material";

function CustomCarousel({ children, data, marginTop = "15px", borderWidth = "4px", borderRadius= "15px", onDelete= () => {}, onReplace = () => {} }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [timeID, setTimeID] = useState(null);

  useEffect(() => {
    if (timeID) clearTimeout(timeID);

    const newTimeout = setTimeout(() => {
      slideNext();
    }, 8000);

    setTimeID(newTimeout);

    return () => clearTimeout(newTimeout);
  }, [activeIndex]);

  const slideNext = () => {
    setActiveIndex((prevIndex) =>
      prevIndex >= children.length - 1 ? 0 : prevIndex + 1
    );
  };

  const slidePrev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex <= 0 ? children.length - 1 : prevIndex - 1
    );
  };

  const AutoPlayStop = () => {
    if (timeID) clearTimeout(timeID);
  };

  const AutoPlayStart = () => {
    const newTimeout = setTimeout(() => {
      slideNext();
    }, 5000);
    setTimeID(newTimeout);
  };

  return (
    <div
      className="container__slider"
      onMouseEnter={AutoPlayStop}
      onMouseLeave={AutoPlayStart}
      style={{ marginTop: marginTop, borderRadius: borderRadius, border: `${borderWidth} solid #ffffff20` }}
    >
      <div className="slider__wrapper" style={{ transform: `translateX(-${activeIndex * 100}%)` }}>
        {children.map((item, index) => (
          <div className="slider__item" key={index}>
            {item}
          </div>
        ))}
      </div>

      <div className="container__slider__links">
        {children.map((_, index) => (
          <button
            key={index}
            className={
              activeIndex === index
                ? "container__slider__links-small container__slider__links-small-active"
                : "container__slider__links-small"
            }
            onClick={() => setActiveIndex(index)}
          ></button>
        ))}
      </div>
  

      <button className="slider__btn-next" onClick={slideNext}>
        <KeyboardArrowRightRounded style={{ fontSize: "25px" }} />
      </button>
      <button className="slider__btn-prev" onClick={slidePrev}>
        <KeyboardArrowLeftRounded style={{ fontSize: "25px" }} />
      </button>

      <button className="slider__btn-delete" onClick={() => {onDelete(data[activeIndex])}}>
        <DeleteOutlineOutlined style={{ fontSize: "25px" }} />
      </button>

      <button className="slider__btn-rotate" onClick={() => {onReplace(data[activeIndex])}}>
        <AutorenewRounded style={{ fontSize: "25px" }} />
      </button>
    </div>
  );
}

export default CustomCarousel;
